import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'

import { Box } from '../components/box'
import { Breadcrumbs } from '../components/breadcrumbs'
import { Container } from '../components/layout/grid'
import { PageMeta } from '../contentful-components/page-meta'
import { SectionOfThumbnails } from '../contentful-components/section-of-thumbnails'
import { SectionResolver } from '../contentful-components/section-resolver'
import type { ArticlePageFragment } from '../graphql/fragments/ArticlePageFragment.graphql'
import type { PageFragment } from '../graphql/fragments/PageFragment.graphql'
import type { PageMetaFragment } from '../graphql/fragments/PageMetaFragment.graphql'
import { EMPTY_SECTION } from '../graphql/placeholders'
import { useUIStore } from '../lib/store/useUIStore'
import { TEXT } from '../lib/utils/text'
import { LINK } from '../shared/util/link'

export const ArticleTopicPageTemplate: FunctionComponent<{
    page?: PageFragment
    title?: string
    meta?: PageMetaFragment
    articles?: { items: ArticlePageFragment[] }
}> = ({ page, title, meta, articles }) => {
    const router = useRouter()
    const { webview } = useUIStore()

    return (
        <>
            {meta && (
                <PageMeta id={meta.sys.id} meta={meta} name={title ?? ''} />
            )}

            <Container>
                <Box pad={['vertical']}>
                    <Breadcrumbs
                        links={[
                            {
                                text: TEXT.money101,
                                href: LINK.money101(
                                    webview.isWebview
                                ).serialize(router),
                            },
                        ]}
                        current={title ?? ''}
                    />
                </Box>
            </Container>

            <Box pad={['bottom']}>
                <SectionOfThumbnails
                    sys={{
                        id: 'topic',
                    }}
                    type='SectionOfThumbnails'
                    thumbnails={articles}
                    section={{
                        ...EMPTY_SECTION,
                        title,
                    }}
                />
            </Box>

            <Box pad={['bottom']}>
                <SectionResolver sections={page?.sections?.items ?? []} />
            </Box>
        </>
    )
}
